import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layouts
import MainLayout from './components/MainLayout';
import AuthLayout from './components/AuthLayout';

// Pages
import Homepage from './pages/Homepage/Homepage';
import LoginPage from './pages/LoginPage/LoginPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import ProductDetailPage from './pages/ProductDetailPage/ProductDetailPage';
import CartPage from './pages/CartPage/CartPage';
import SearchPage from './pages/SearchPage/SearchPage';
import AboutPage from './pages/AboutPage/AboutPage';
import HowToUsePage from './pages/HowToUsePage/HowToUsePage';

// Proteksi Rute
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      {/* Rute dengan Navbar dan Footer */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Homepage />} />
        <Route path="/search" element={<SearchPage />} />

        {/* --- PERBAIKAN DI SINI: Sesuaikan path dengan link dari ProductCard --- */}
        <Route path="/barang/customer/:id" element={<ProductDetailPage />} />
        
        <Route path="/cart" element={<CartPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/how-to-use" element={<HowToUsePage />} />
        <Route 
          path="/profile" 
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          } 
        />
      </Route>

      {/* Rute tanpa Navbar dan Footer */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>
    </Routes>
  );
}

export default App;